module.exports = __webpack_public_path__ + "img/WeChata343dd53120348645eb6d712ce0309ac.a343dd53.png";